import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (
  state = generateCreateDefaultState('FOOD_SHOPPING'),
  action
) => {
  return createJobDefaultReducer('FOOD_SHOPPING', action, state);
};
